import type { DossierSection } from '../types/dossier'

export const dossierSections: DossierSection[] = [
  { id: 'gancho', number: '01', label: 'El Gancho' },
  { id: 'agitacion', number: '02', label: 'Agitación del Dolor' },
  { id: 'revelacion', number: '03', label: 'La Revelación' },
  { id: 'oferta', number: '04', label: 'La Oferta' },
  { id: 'precio', number: '05', label: 'Precio y Valor' },
  { id: 'garantia', number: '06', label: 'Garantía' },
  { id: 'faq', number: '07', label: 'FAQ' },
  { id: 'cierre', number: '08', label: 'Cierre' }
]
